module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-details/land-project-details/land-project-details.component.css
// module id = ./src/app/landprocurement/land-details/land-project-details/land-project-details.component.css
// module chunks = main